__turbopack_context__.v({
  "container": "FormLayout-module-scss-module__CvL2xq__container",
  "content": "FormLayout-module-scss-module__CvL2xq__content",
  "footer": "FormLayout-module-scss-module__CvL2xq__footer",
  "header": "FormLayout-module-scss-module__CvL2xq__header",
  "root": "FormLayout-module-scss-module__CvL2xq__root",
});
